export { default as InventoryViewStore } from './InventoryViewStore';
